module.exports = __webpack_public_path__ + "img/social_credit.f5b54e53.png";